<template>
    <div class="terms">
        <h2>제1장. 개인정보의 처리 목적</h2>
        <p
            >주식회사 매일국어(이하 “회사”라고 합니다.)는 운영하는 웹사이트 매일국어T(school.dailykor.com, 이하
            “웹사이트”라고 합니다.)을 통하여 제공하는 교육서비스(이하 “서비스”라고 합니다.)를 이용하는 회원의 개인정보를
            소중하게 생각하고, 회원의 개인정보를 보호하기 위하여 최선을 다해 노력하고 있습니다.</p
        >
        <p
            >회사는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는
            이용되지 않으며, 이용 목적이 변경되는 경우에는 『개인정보 보호법』 제18조에 따라 별도의 동의를 받는 등
            필요한 조치를 이행할 예정 입니다.</p
        >
        <table>
            <colgroup>
                <col style="width: 30%" />
                <col style="width: 70%" />
            </colgroup>
            <thead>
                <tr>
                    <th>목적</th>
                    <th>내용</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>서비스 제공</td>
                    <td class="text_left"
                        >상담/문의, 학습자료 제공, 구매 및 요금 결제, 물품배송 또는 청구서 등 발송, 본인인증(금융거래,
                        금융서비스) 등 서비스 제공에 관한 계약의 이행 및 요금정산, 성적 및 분석 결과 확인, 서비스 이용
                        이력 저장 등에 관련한 목적으로 개인정보를 처리합니다.
                    </td>
                </tr>
                <tr>
                    <td>회원 가입 및 관리</td>
                    <td class="text_left"
                        >서비스 이용에 따른 본인확인, 개인 식별 등을 목적으로 개인정보를 처리합니다.</td
                    >
                </tr>
                <tr>
                    <td
                        >신규 서비스개발 <br />
                        마케팅 및 광고에 활용</td
                    >
                    <td class="text_left">
                        이벤트 정보 및 참여 기회 제공, 광고성 정보 제공 등 마케팅 프로모션, 관계사 상품 소개, 접속 빈도
                        파악 또는 회원의 서비스 이용에 대한 통계 등을 목적으로 개인정보를 처리합니다.
                    </td>
                </tr>
            </tbody>
        </table>
        <h2>제2장. 개인정보의 처리 및 보유기간</h2>
        <p
            >회사는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의 받은 개인정보
            보유·이용기간 내에서 개인정보를 처리·보유 합니다. 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.</p
        >
        <table>
            <colgroup>
                <col style="width: 22%" />
                <col style="width: 26%" />
                <col style="width: 26%" />
                <col style="width: 26%" />
            </colgroup>
            <thead>
                <tr>
                    <th>개인정보 유형</th>
                    <th>보유 목적</th>
                    <th>관련 근거</th>
                    <th>보유 기간</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td rowspan="2">회원 정보</td>
                    <td>서비스 제공, 서비스 이용에 대한 공지 및 상담</td>
                    <td>정보주체 동의</td>
                    <td>탈퇴 후 지체없이 파기(단 ‘ID’ 정보는 부정사용 방지 및 재가입 금지를 위해 영구 보관)</td>
                </tr>
                <tr>
                    <td>서비스 이용 및 상담, 소비자 불만, 분쟁처리에 관한 기록</td>
                    <td>전자상거래 등에서의 소비자보호에 관한 법률</td>
                    <td>3년</td>
                </tr>
                <tr>
                    <td rowspan="2">결제 정보</td>
                    <td>주문 상품의 결제 및 환불, 배송</td>
                    <td>정보주체 동의</td>
                    <td>법정 의무 보관기간</td>
                </tr>
                <tr>
                    <td>계약 또는 청약 철회에 관한 기록</td>
                    <td>전자상거래 등에서의 소비자보호에 관한 법률</td>
                    <td>5년</td>
                </tr>
                <tr>
                    <td rowspan="2">기타 서비스</td>
                    <td>부정 이용자 식별</td>
                    <td>통신비밀보호법</td>
                    <td>3개월</td>
                </tr>
                <tr>
                    <td>현금영수증 발급, 제세공과금 처리</td>
                    <td>소득세법</td>
                    <td>5년</td>
                </tr>
                <tr>
                    <td rowspan="3">신규 서비스개발<br />마케팅 및 광고에 활용</td>
                    <td>이벤트 상품 발송</td>
                    <td>정보주체 동의</td>
                    <td>이용 목적 달성 후 즉시 파기</td>
                </tr>
                <tr>
                    <td
                        >정기 간행물 발송,<br />
                        새로운 상품 또는 서비스 안내</td
                    >
                    <td>정보주체 동의</td>
                    <td>탈퇴 후 지체없이 파기</td>
                </tr>
                <tr>
                    <td>설명회 안내</td>
                    <td>정보주체 동의</td>
                    <td>탈퇴 후 지체없이 파기</td>
                </tr>
            </tbody>
        </table>
        <p>다만, 다음의 사유에 해당하는 경우에는 해당 사유 종료 시 까지 처리 및 보유합니다.</p>
        <table>
            <colgroup>
                <col style="width: 40%" />
                <col style="width: 40%" />
                <col style="width: 20%" />
            </colgroup>
            <thead>
                <tr>
                    <th>관련 법령</th>
                    <th>보유 항목</th>
                    <th>보유 기간</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td rowspan="4">전자상거래 등에서의 소비자 보호에 관한 <br />법률 및 동법 시행령</td>
                    <td>계약 또는 청약 철회에 관한 기록</td>
                    <td>5년</td>
                </tr>
                <tr>
                    <td>대금결제 및 재화 등의 공급에 관한 기록</td>
                    <td>5년</td>
                </tr>
                <tr>
                    <td>소비자의 불만 또는 분쟁처리에 관한 기록</td>
                    <td>3년</td>
                </tr>
                <tr>
                    <td>표시·광고에 관한 기록</td>
                    <td>6개월</td>
                </tr>
                <tr>
                    <td>통신비밀보호법 및 동법 시행령</td>
                    <td>인터넷 로그기록, 접속지 추적자료</td>
                    <td>3개월</td>
                </tr>
            </tbody>
        </table>
        <h2>제3장. 처리하는 개인정보 항목</h2>
        <ol>
            <li
                >회사의 서비스 제공을 위한 정보(필수 항목)와 회원의 기호와 필요에 따른 서비스를 제공하기 위해 추가적으로
                제공이 요구되는 정보(선택 항목)로 구분하여 회원의 개인정보를 수집하고 있습니다. 회원 가입 시 필수 정보의
                제공에 동의하지 않을 경우, 서비스 제공을 받기 어렵다는 점을 설명해드리고 있으며, 선택 정보 제공에
                동의하지 않는 경우에는 서비스 이용 제한이 없음을 안내드립니다. 또한, 이용자의 기본적 인권 침해의 우려가
                있는 민감한 개인정보(인종 및 민족, 사상 및 신조, 출신지 및 본적지, 정치적 성향 및 범죄기록, 건강상태
                등)는 수집하지 않습니다.<br />
                소득세법에 따라 경품 수령을 위한 제세공과금 처리 목적으로 고객의 주민등록번호, 계좌번호 및 주소 정보를
                수집할 수 있습니다. (시행규칙 제100조 제25호)
            </li>
        </ol>
        <table>
            <colgroup>
                <col style="width: 20%" />
                <col style="width: 10%" />
                <col style="width: 40%" />
                <col style="width: 30%" />
            </colgroup>
            <thead>
                <tr>
                    <th>개인정보 유형</th>
                    <th colspan="2">개인정보 항목</th>
                    <th>수집방법</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>회원 정보</td>
                    <td>필수</td>
                    <td class="text_left">아이디, 비밀번호, 이름, 학교, 휴대폰 번호</td>
                    <td>웹사이트 회원 가입 및 정보수정</td>
                </tr>
                <tr>
                    <td></td>
                    <td>선택</td>
                    <td class="text_left">이메일</td>
                    <td>웹사이트 회원 가입 및 정보수정</td>
                </tr>
                <tr>
                    <td>결제 정보</td>
                    <td>선택</td>
                    <td class="text_left">(신용카드정보) 카드사명, 카드번호, 소유자명, 생년월일</td>
                    <td>웹사이트 결제</td>
                </tr>
                <tr>
                    <td>환불정보</td>
                    <td>선택</td>
                    <td class="text_left">(계좌정보) 은행명, 예금주명, 계좌번호</td>
                    <td>상담전화</td>
                </tr>
                <tr>
                    <td>상담정보</td>
                    <td>필수</td>
                    <td class="text_left">휴대폰번호, 이름, 상담내용</td>
                    <td>상담전화</td>
                </tr>
                <tr>
                    <td>
                        신규 서비스개발 <br />
                        마케팅 및 광고에 활용
                    </td>
                    <td>선택</td>
                    <td class="text_left"> 아이디, 이름, 학교, 휴대폰번호, 이메일 </td>
                    <td> 웹사이트 회원 가입 및 정보수정 </td>
                </tr>
            </tbody>
        </table>
        <ol start="2">
            <li
                >회사는 다음과 같은 방법으로 개인정보를 수집할 수 있으며 개인식별이 가능한 개인정보를 수집하는 경우에는
                고객으로부터 동의를 받습니다. 고객이 동의 버튼을 클릭하거나, 정보 수정 등을 통해 추가로 수집하는
                개인정보를 기재한 후 저장할 경우 개인정보 수집에 동의한 것으로 봅니다.<br />
                ① 웹사이트, 서면, 팩스, 전화, 고객센터 문의하기, 이벤트 응모<br />
                ② 서비스 이용 과정에서 자동으로 생성되는 정보
            </li>
        </ol>
        <table>
            <colgroup>
                <col style="width: 33%" />
                <col style="width: 33%" />
                <col style="width: 34%" />
            </colgroup>
            <thead>
                <tr>
                    <th>수집 및 이용 목적</th>
                    <th>수집항목</th>
                    <th>보유기간</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>서비스 이용기록 및 통계분석, 부정이용 방지, 개인정보 침해사고 대비</td>
                    <td>IP주소, 쿠키, 접속 일시, 서비스 이용기록, 로그 정보</td>
                    <td>회원탈퇴 시 또는 법정 의무 보관기간 (쿠키는 브라우저 종료 시 또는 로그아웃 시 만료)</td>
                </tr>
            </tbody>
        </table>
        <ol start="3">
            <li
                >회사는 통계 작성, 과학적 연구, 공익적 기록보존 등을 위하여 개인정보를 가명처리하여 활용할 수
                있습니다.</li
            >
        </ol>
        <h2>제4장. 만 14세 미만 아동의 개인정보 처리에 관한 사항</h2>
        <ol>
            <li
                >회사는 만14세 미만 아동(이하 '아동')이 제공한 개인정보로 인하여 아동 및 법정대리인이 불이익을 입지
                않도록 보호 조치를 취하고 있습니다.</li
            >
            <li
                >회사는 아동의 개인정보를 수집할 때 법정대리인의 동의를 얻어 해당 서비스 수행에 필요한 최소한의
                개인정보를 수집하며, 이 경우 아동이 쉽게 이해할 수 있는 평이한 표현으로 법정대리인의 동의가 필요하다는
                취지를 아동에게 고지합니다.<br />
                - 필수항목 : 법정대리인의 성명, 생년월일, 연락처
            </li>
            <li
                >회사는 아동의 개인정보에 대하여 아래의 행위를 하는 경우에는 해당 아동의 법정대리인의 동의를 얻도록 하고
                있습니다.<br />
                ① 아동의 서비스 가입 시 고지한 범위 또는 서비스 이용약관에 명시한 범위를 넘어 아동의 개인정보를
                이용하거나 제 3 자에게 제공하고자 하는 경우<br />
                ② 아동의 개인정보를 제공받은 자가 개인정보를 제공받은 목적 외의 용도로 이용하거나 제 3 자에게 제공하는
                경우
            </li>
            <li
                >법정대리인의 동의를 얻기 위하여 수집한 법정대리인의 개인정보를 해당 법정대리인의 동의 여부를 확인하는
                목적 외의 용도로 이를 이용하거나 제 3 자에게 제공하지 않습니다.</li
            >
        </ol>
        <h2>제5장. 개인정보 처리의 위탁</h2>
        <ol>
            <li
                >회사는 기본적인 서비스 제공, 서비스 향상, 고객 편의 제공 등 원활한 업무 수행을 위하여 다음과 같이
                개인정보 처리 업무를 외부 전문 업체에 위탁하여 운영하고 있습니다.</li
            >
        </ol>
        <table>
            <colgroup>
                <col style="width: 50%" />
                <col style="width: 50%" />
            </colgroup>
            <thead>
                <tr>
                    <th>위탁 업무 내용</th>
                    <th>수탁 기관명</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>결제 서비스</td>
                    <td>(주)헥토파이낸셜</td>
                </tr>
                <tr>
                    <td>문자메시지, 카카오 알림톡 발송</td>
                    <td>(주)알리는사람들</td>
                </tr>
                <tr>
                    <td>배송업무</td>
                    <td>우체국, CJ대한통운, 한진택배</td>
                </tr>
            </tbody>
        </table>
        <ol start="2">
            <li
                >회사는 위탁계약 체결 시 『개인정보보호법』 제26조에 따라 위탁업무 수행목적 외 개인정보 처리금지,
                기술적·관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리·감독, 손해배상 등 책임에 관한 사항을 계약서 등
                문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.
            </li>
            <li>위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보 처리방침을 통하여 공개합니다.</li>
            <li
                >회사는 원칙적으로 이용자의 개인정보를 제3자에게 제공하지 않습니다. <br />
                다만, 관련 법령의 규정에 의거하거나 수사 목적으로 법령에 정해진 절차와 방법에 따른 수사기관의 요구가
                있는 경우, 이용자가 사전에 동의한 경우에 한하여 개인정보를 제3자에게 제공할 수 있습니다.<br />
                개인정보의 제3자 제공이 발생하는 경우, 회사는 고객의 사전 동의를 받고 해당 내용을 개인정보 처리방침에
                공개합니다.
            </li>
        </ol>
        <h2>제6장. 개인정보 파기</h2>
        <ol>
            <li
                >회사는 개인정보 보유기간의 경과, 회원탈퇴 등 처리목적이 달성되거나 동의철회 요청이 있는 경우 지체없이
                해당 개인정보를 파기합니다.</li
            >
            <li
                >정보주체로부터 동의받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 내부방침과
                관련 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로
                옮기거나 보관장소를 달리하여 보존합니다. 일반적으로 전자적 파일형태로 관리하는 개인정보는 탈퇴 시점에
                바로 삭제됩니다.
            </li>
            <li
                >개인정보 파기 방법은 다음과 같습니다.<br />
                ① 종이에 출력된 개인정보는 분쇄기로 분쇄 또는 소각을 통하여 파기<br />
                ② 전자적 파일형태로 저장된 개인정보는 기록을 복구·재생할 수 없는 기술적 방법을 사용하여 완전 삭제
            </li>
        </ol>
        <h2>제7장. 미 이용자의 개인정보 파기 등에 관한 조치</h2>
        <ol>
            <li
                >회사는 『개인정보보호법』 제39조의6 제1항에 따라 휴면고객(최근 12개월 동안 서비스를 이용하지 아니한
                고객)에 대해 서비스를 해지하며 고객의 개인정보를 파기하고 있습니다. 다만, 다른 법령에서 정한 보존기간이
                경과할 때까지의 다른 이용자의 개인정보와 분리하여 별도로 저장·관리할 수 있습니다.
            </li>
            <li
                >회사는 개인정보의 파기 30일 전까지 개인정보가 파기되는 사실, 기간 만료일 및 파기되는 개인정보의 항목을
                이메일, 문자 등 고객에게 통지 가능한 방법으로 알리고 있습니다.</li
            >
            <li>개인정보의 파기를 원하지 않으시는 경우, 기간 만료 전 서비스 로그인을 하시면 됩니다.</li>
        </ol>
        <h2>제8장. 정보주체의 권리, 의무 및 행사방법</h2>
        <ol>
            <li
                >정보주체의 권리와 의무<br />
                ① 회원의 개인정보를 최신의 상태로 정확하게 입력하여 불의의 사고를 예방해 주시기 바랍니다. 부정확한 정보
                입력으로 말미암아 발생하는 사고의 책임은 회원에게 있으며 타인의 정보를 무단으로 사용하는 등 허위정보를
                입력하면 서비스 이용 자격이 상실될 수 있습니다.<br />
                ② 회원은 개인정보를 보호받을 권리와 함께 자신을 스스로를 보호하고 타인의 정보를 침해하지 않을 의무도
                지니고 있습니다. 비밀번호(Password)를 포함한 회원의 개인정보가 유출되지 않도록 조심하시고 게시물을
                포함한 타인의 개인정보를 훼손하지 않도록 유의해 주십시오. 만약 이 같은 책임을 다하지 못하고 타인의
                정보를 훼손할 때에는 『정보통신망 이용촉진 및 정보보호 등에 관한 법률』 등에 의해 처벌받을 수 있습니다.
            </li>
            <li
                >회원 및 법정대리인의 권리와 의무 행사방법<br />
                ① 회원 및 법정대리인은 본인확인 등의 절차를 거쳐 아래와 같은 방법으로 홈페이지, 전화를 통하여 언제든지
                등록되어 있는 본인 혹은 만 14세 미만 아동의 개인정보를 조회하거나 수정, 가입 해지(동의철회), 삭제를
                요청할 수 있으며, 회사는 이에 대하여 지체없이 조치를 취하겠습니다.<br />
                - 조회 및 수정 : 로그인 후 마이페이지 &gt; 정보 수정<br />
                - 가입 해지(동의철회), 삭제 : 로그인 후 마이페이지 &gt; 회원 탈퇴<br />
                - 마케팅 정보 수신 동의철회 : 로그인 후 마이페이지 &gt; 정보 수정
            </li>
            <li>웹사이트를 통해 직접 확인하지 못하는 정보는 고객센터(1800-5039)로 요청하여 확인할 수 있습니다.</li>
        </ol>
        <h2>제9장. 개인정보의 안정성 확보 조치</h2>
        <p>회사는 이용자의 개인정보의 안전성 확보를 위해 다음과 같이 관리적, 기술적, 물리적 조치를 취하고 있습니다.</p>
        <table>
            <colgroup>
                <col style="width: 35%" />
                <col style="width: 65%" />
            </colgroup>
            <thead>
                <tr>
                    <th>조치</th>
                    <th>내용</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td class="text_left">개인정보 취급 직원의 최소화 및 교육</td>
                    <td class="text_left"
                        >개인정보를 취급하는 직원을 지정하고 담당자에 한정시켜 최소화 하여 개인정보를 관리하는 대책을
                        시행하고 있습니다.</td
                    >
                </tr>
                <tr>
                    <td class="text_left">정기적인 자체 감사 실시</td>
                    <td class="text_left"
                        >개인정보 취급 관련 안정성 확보를 위해 정기적으로 자체 감사를 실시하고 있습니다.</td
                    >
                </tr>
                <tr>
                    <td class="text_left">내부관리계획의 수립 및 시행</td>
                    <td class="text_left"
                        >개인정보의 안전한 처리를 위하여 내부관리계획을 수립하고 시행하고 있습니다.</td
                    >
                </tr>
                <tr>
                    <td class="text_left">개인정보의 암호화</td>
                    <td class="text_left"
                        >고객님의 개인정보 비밀번호는 일방향 암호화 되어 저장 및 관리되고 있어, 개인정보의 확인 및
                        변경은 비밀번호를 알고 있는 본인에 의해서만 가능합니다. 중요한 데이터는 파일 및 전송 데이터를
                        암호화 하거나 파일 잠금 기능을 사용하는 등의 별도 보안기능을 사용하고 있습니다.
                    </td>
                </tr>
                <tr>
                    <td class="text_left">해킹 등에 대비한 기술적 대책</td>
                    <td class="text_left"
                        >해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기 위하여 보안프로그램을 설치하고
                        주기적인 갱신·점검을 하며 외부로부터 접근이 통제된 구역에 시스템을 설치하고 기술적/물리적으로
                        감시 및 차단하고 있습니다.
                    </td>
                </tr>
                <tr>
                    <td class="text_left">개인정보에 대한 접근 제한</td>
                    <td class="text_left"
                        >개인정보를 처리하는 데이터베이스시스템에 대한 접근권한의 부여, 변경, 말소를 통하여 개인정보에
                        대한 접근통제를 위하여 필요한 조치를 하고 있으며 침입차단시스템을 이용하여 외부로부터의 무단
                        접근을 통제하고 있습니다.
                    </td>
                </tr>
                <tr>
                    <td class="text_left">접속기록의 보관 및 위·변조 방지</td>
                    <td class="text_left"
                        >개인정보처리시스템에 접속한 기록을 2년이상 보관, 관리하고 있으며, 접속 기록이 위·변조 및 도난,
                        분실되지 않도록 보안기능을 사용하고 있습니다.</td
                    >
                </tr>
                <tr>
                    <td class="text_left">문서보안을 위한 잠금장치 사용</td>
                    <td class="text_left"
                        >개인정보가 포함된 서류, 보조저장매체 등을 잠금장치가 있는 안전한 장소에 보관하고 있습니다.</td
                    >
                </tr>
                <tr>
                    <td class="text_left">비 인가자에 대한 출입 통제</td>
                    <td class="text_left"
                        >개인정보를 보관하고 있는 물리적 보관 장소를 별도로 두고 이에 대해 출입통제 절차를 수립,
                        운영하고 있습니다.</td
                    >
                </tr>
            </tbody>
        </table>
        <h2>제10장. 개인정보 자동수집 장치의 설치, 운영 및 거부에 관한 사항</h2>
        <ol>
            <li
                >회사는 고객에게 개별적인 맞춤서비스를 제공하기 위해 이용 정보를 저장하고 수시로 불러오는
                ‘쿠키(cookie)’를 사용합니다. 쿠키는 웹사이트를 운영하는데 이용되는 서버가 이용자의 컴퓨터 브라우저에
                보내는 소량의 정보이며 이용자들의 컴퓨터에 저장되어 운영 됩니다.
            </li>
            <li
                >쿠키의 사용 목적 : 회원이 방문한 각 서비스와 웹사이트들에 대한 방문 및 이용형태, 인기 검색어, 보안접속
                여부 등을 파악하여 최적화된 정보 제공을 위해 사용 됩니다.</li
            >
            <li
                >쿠키의 설치·운영 및 거부 : 웹브라우저 설정을 통해 쿠키 저장을 거부할 수 있습니다.<br />
                - Chrome : 설정 메뉴 &gt; 고급 설정 표시 선택 &gt; 개인정보-콘텐츠 설정 &gt; 쿠키 수준 설정<br />
                - Microsoft Edge : 인터넷옵션 메뉴 &gt; 개인정보 &gt; 고급 &gt; 고급 개인정보 설정<br />
                - firefox : 옵션 메뉴 &gt; 개인정보 &gt; 방문기록-사용자 정의 설정 &gt; 쿠키 수준 설정<br />
                - safari : 환경설정 메뉴 &gt; 개인정보 탭 &gt; 쿠키 및 웹 사이트 데이터 수준 설정
            </li>
            <li>쿠키 저장을 거부할 경우 서비스 이용에 어려움이 발생할 수 있습니다.</li>
        </ol>
        <h2>제11장. 개인정보 보호책임자에 관한 사항</h2>
        <p
            >회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및
            피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.<br />
            회사의 서비스를 이용하면서 발생한 모든 개인정보보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보
            보호책임자 및 담당부서로 문의할 수 있습니다.</p
        >
        <table>
            <colgroup>
                <col style="width: 30%" />
                <col style="width: 35%" />
                <col style="width: 35%" />
            </colgroup>
            <thead>
                <tr>
                    <th>구분</th>
                    <th>개인정보 보호책임자</th>
                    <th>개인정보 보호 담당 부서</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>담당부서</td>
                    <td>콘텐츠팀</td>
                    <td>회계총무팀</td>
                </tr>
                <tr>
                    <td>성명</td>
                    <td>전용선 팀장</td>
                    <td>박수아 사원</td>
                </tr>
                <tr>
                    <td>전화번호</td>
                    <td>1800-5039</td>
                    <td>1800-5039</td>
                </tr>
                <tr>
                    <td>이메일주소</td>
                    <td><a href="mailto:jys0321@dailykor.com">jys0321@dailykor.com</a></td>
                    <td><a href="mailto:qkrtndk321@dailykor.com">qkrtndk321@dailykor.com</a></td>
                </tr>
            </tbody>
        </table>
        <h2>제12장. 개인정보 처리 방침의 변경</h2>
        <p>이 개인정보 처리방침은 2025. 01. 01부터 적용됩니다.</p>
    </div>
</template>

<script setup lang="ts">
    import { PropType } from 'vue';

    const props = defineProps({
        className: {
            type: String as PropType<string>,
            required: false,
            default: null,
        },
    });
</script>
